/* unplugin-vue-components disabled */import { render } from "./BannerList.vue?vue&type=template&id=05bb8dda&scoped=true"
import script from "./BannerList.vue?vue&type=script&lang=js"
export * from "./BannerList.vue?vue&type=script&lang=js"

import "./BannerList.vue?vue&type=style&index=0&id=05bb8dda&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈工程-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bb8dda"]])

export default __exports__